import Image from 'next/image'
import Link from 'next/link'

import { getArticleUrl } from '@/lib/api-connector-strapi-cms/utils/getArticleUrl.utils'
import { ImageType } from '@/lib/models/components/image.types'

export type CardArticleProps = {
  category?: string
  title: string
  description: string
  authorName: string
  datePublication: string
  linkArticle: string
  image: ImageType
}

export const CardSearchResult = ({
  category,
  title,
  description,
  authorName,
  datePublication,
  linkArticle,
  image,
}: CardArticleProps) => {
  return (
    <Link
      href={getArticleUrl(linkArticle)}
      className="card-article-promoted group flex min-h-[16rem] cursor-pointer px-6 md:h-[440px] md:justify-between md:px-0 md:pl-10"
    >
      <div className="pb-8 md:pb-16">
        <div className="aspec relative mb-4 aspect-[240/180] w-full pb-4 md:pb-0 xl:h-[180px] xl:w-[240px]">
          <Image
            className="index-0 absolute block xl:left-0 xl:top-0"
            src={image.url}
            layout="fill"
            objectFit="cover"
            alt={image.alternativeText || `${title} image`}
          />
        </div>
        <div className="flex h-[194px] flex-1 flex-col justify-between md:h-[212px]">
          <div className="">
            {category && <div className="caption pb-4">{category}</div>}
            <div className="card-article-promoted-title paragraph-xxl mb-2 font-semibold">
              {title}
            </div>
            <div className="paragraph-s text-gray-800">{`${authorName}  •  ${datePublication}`}</div>
          </div>
          <div className="card-article-promoted-text paragraph-s">
            {description}
          </div>
        </div>
      </div>
    </Link>
  )
}
